module.exports = __webpack_public_path__ + "static/media/home_lock_icon.10d79270.png";